import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import React from 'react';

const ServiceRequirementToggle = ({
  isRequired = false,
  isDefault = false,
  onRequiredChange = () => { },
  onDefaultChange = () => { }
}) => {
  return (
    <div>
      <Typography variant="body1" mb={1}>
        Service Requirement Type
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
        <FormControlLabel
          control={
            <Switch
              checked={isRequired}
              onChange={(e) => onRequiredChange(e.target.checked)}
              color="primary"
            />
          }
          label="Required"
        />
        <FormControlLabel
          control={
            <Switch
              checked={isDefault}
              onChange={(e) => onDefaultChange(e.target.checked)}
              color="primary"
            />
          }
          label="Default"
        />
      </Box>
    </div>
  );
};

export default ServiceRequirementToggle;
